<div class="announcements-container">
  <div class="page-section-header">
    <div *ngIf="!isLoading && organizations?.length > 0" class="page-section-buttons">
      <a (click)="doCreate()" (keypress)="doCreate()"
        class="app-c-btn app-c-btn--primary app-c-btn--curve app-c-btn--with-icon">
        <svg-icon icon="plus" alt="plus"></svg-icon>
        <span translate>Create Announcement</span>
      </a>
    </div>
    <h2>Announcement Activities</h2>
  </div>

  <!-- Announcements List -->
  <div class="announcements-list">
    <div *ngIf="isLoading" class="loading">
      Loading announcements...
    </div>
    
    <div *ngIf="!isLoading && activeAnnouncements.length === 0 && expiredAnnouncements.length === 0" class="no-announcements">
      No announcements available
    </div>

    <div *ngIf="!isLoading && (activeAnnouncements.length > 0 || expiredAnnouncements.length > 0)" class="table-responsive">
      <table class="table">
        <thead>
          <tr>
            <th style="width: 20%">Organization</th>
            <th style="width: 30%">Message Title</th>
            <th style="width: 15%">Start Date</th>
            <th style="width: 15%">End Date</th>
            <th style="width: 5%"></th>
            <th style="width: 5%">Actions</th>
            <th style="width: 5%"></th>
            <th style="width: 5%"></th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let announcement of activeAnnouncements">
            <td>{{ announcement.OrgName }}</td>
            <td>{{ announcement.Title }}</td>
            <td>{{ announcement.StartDate | date }}</td>
            <td>{{ announcement.EndDate | date }}</td>
            <td><a tabindex="0" class="pull-right"  (click)="viewAnnouncement(announcement)" translate>View</a></td>
            <td><a tabindex="0" class="pull-right" (click)="editAnnouncement(announcement)" translate>Edit</a></td>
            <td><a tabindex="0" class="pull-right" (click)="endAnnouncement(announcement)" translate>End</a></td>
            <td><a class="trigger-modal delete pull-right" tabindex="0" aria-label="Delete announcement"
              (click)="deleteAnnouncement(announcement)" (keypress)="deleteAnnouncement(announcement)">
              <svg-icon icon="trash" class="table-icon"></svg-icon>
            </a></td>
          </tr>
          <tr *ngFor="let announcement of expiredAnnouncements" class="expired">
            <td>{{ announcement.OrgName }}</td>
            <td>{{ announcement.Title }}</td>
            <td>{{ announcement.StartDate | date }}</td>
            <td>{{ announcement.EndDate | date }}</td>
            <td><a tabindex="0" class="pull-right" (click)="viewAnnouncement(announcement)" translate>View</a></td>
            <td></td>
            <td></td>
            <td><a class="trigger-modal delete pull-right" tabindex="0" aria-label="Delete announcement"
              (click)="deleteAnnouncement(announcement)" (keypress)="deleteAnnouncement(announcement)">
              <svg-icon icon="trash" class="table-icon"></svg-icon>
            </a></td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</div> 